export interface IStepperInitialState {
  isDrop?: boolean,
  isShowDropButton?: boolean
}

export const stepperInitialState:IStepperInitialState = {
  isDrop: false,
  isShowDropButton: false
};
